import type { IParsedNotification, IUnreadCountResponse } from "../types";

export interface IApplyNotificationCreatedToUnreadCountProps {
  oldData: IUnreadCountResponse | undefined;
  notification: IParsedNotification;
}

// NOTE: NSAI-5911 — the unread count drives the bell badge and the favicon
// badge, and the favicon is the one piece of the app a user still sees while
// the tab is hidden. Refetching the count on every `notification:created` is
// what the deferral removed, so the push payload patches the cached count in
// place instead (an unread row adds one); the deferred refetch reconciles it
// with the server once the tab is visible again. No cached count yet means
// nothing is rendering it — leave it for the first fetch.
export const applyNotificationCreatedToUnreadCount = ({
  oldData,
  notification,
}: IApplyNotificationCreatedToUnreadCountProps):
  | IUnreadCountResponse
  | undefined => {
  if (!oldData || notification.isRead) return oldData;
  return { ...oldData, count: oldData.count + 1 };
};
